<template>
	<el-form :model="form" style="padding: 20px;" class="formBox">
		<el-form-item label="商品名称" label-width='100px'>
			<el-input v-model="form.goodsName" autocomplete="off" placeholder="请输入商品名称"></el-input>
		</el-form-item>
		<el-form-item label="商品现价" label-width='100px'>
			<el-input v-model="form.goodsNowPrice" autocomplete="off" placeholder="请输入商品现价"></el-input>
		</el-form-item>
		<el-form-item label="商品原价" label-width='100px'>
			<el-input v-model="form.goodsOrgPrice" autocomplete="off" placeholder="请输入商品原价"></el-input>
		</el-form-item>
		<!-- <el-form-item label="积分" label-width='100px'>
			<el-input v-model.number="form.integral" autocomplete="off" placeholder="请输入积分"></el-input>
		</el-form-item> -->
		<el-form-item label="标签1" label-width='100px'>
			<el-input v-model="form.label1" autocomplete="off" placeholder="请输入标签"></el-input>
		</el-form-item>
		<el-form-item label="标签2" label-width='100px'>
			<el-input v-model="form.label2" autocomplete="off" placeholder="请输入标签"></el-input>
		</el-form-item>
		<el-form-item label="生态积分支付计算" label-width='100px'>
			<el-input v-model="form.promotionIntegralPercent" autocomplete="off" placeholder="N%"></el-input>
		</el-form-item>
		<el-form-item label="一级分类" label-width='100px'>
			<el-select @change='selectClassGoodsType' v-model="form.goodsTypeOneId" placeholder="请选择">
				<el-option v-for="item in classGoodsType" :key="item.goodsTypeId" :label="item.goodsTypeName" :value="item.goodsTypeId">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="二级分类" label-width='100px'>
			<el-select  @change='selectLeveGoodsType' v-model="form.goodsTypeTwoId" placeholder="请选择">
				<el-option v-for="item in leveGoodsType" :key="item.goodsTypeId" :label="item.goodsTypeName" :value="item.goodsTypeId">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="三级分类" label-width='100px'>
			<el-select  v-model="form.goodsTypeThreeId" placeholder="请选择">
				<el-option v-for="item in tertiaryGoodsType" :key="item.goodsTypeId" :label="item.goodsTypeName" :value="item.goodsTypeId">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="供货商" label-width='100px'>
			<el-select v-model="form.supplierId" placeholder="请选择">
				<el-option v-for="item in supplier" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId">
				</el-option>
			</el-select>
		</el-form-item>
		
		<el-form-item label="是否推广商品" label-width='100px'>
			<el-select v-model="form.promotionState" placeholder="请选择">
				<el-option  label="是" :value="1">
				</el-option>
				<el-option  label="否" :value="0">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="奖励积分" label-width='100px' v-if="form.promotionState == 1">
			<el-input v-model="form.promotionCoupons" type="number" autocomplete="off" placeholder="请输入奖励积分"></el-input>
		</el-form-item>

		<el-form-item label="是否热销" label-width='100px'>
			<el-select v-model="form.isHotSale" placeholder="请选择">
				<el-option  label="是" :value="1">
				</el-option>
				<el-option  label="否" :value="2">
				</el-option>
			</el-select>
		</el-form-item>
		
		<!-- <el-form-item label="是否上架" label-width='100px'>
			<el-select v-model="form.isOnShelf" placeholder="请选择">
				<el-option  label="是" :value="1">
				</el-option>
				<el-option  label="否" :value="2">
				</el-option>
			</el-select>
		</el-form-item> -->
		<el-form-item label="今日上新" label-width='100px'>
			<el-select v-model="form.isTodayShelf" placeholder="请选择">
				<el-option  label="是" :value="1">
				</el-option>
				<el-option  label="否" :value="2">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="商品封面图" label-width='100px'>
			<el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'"
				:headers="headers" 
				accept=".png,.jpg"
				:on-error='onError'
				:show-file-list="false" :on-success="handleAvatarSuccess">
				<img v-if="form.goodsHead" :src="webUrl+form.goodsHead" class="avatar">
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
			<!-- <el-input v-model="form.sort"  autocomplete="off" ></el-input> -->
			<div style="color: red;">请上传1:1的图片比例</div>
		</el-form-item>
		<el-form-item label="商品轮播图" label-width='100px'>
			<div style="display: flex;flex-wrap: wrap;">
				<div v-for='(item,index) in form.goodsBannerList' style="position: relative;">
					<i @click="delBanner(index)" class="el-icon-error" style="position: absolute;right:10px;top:0;font-size: 30px;"></i>
					<img style="margin-bottom: 10px;"  :src="webUrl+item.path" class="avatar">
				</div>
				<el-upload style="margin-bottom: 10px;" class="avatar-uploader" :action="upImg+'/file/upload/batch/pic'"
				:headers="headers" :limit='9'
				 :multiple="true"
				 :on-error='onError'
				accept=".png,.jpg"
					:show-file-list="false" :on-success="bannerSuccess">			
					<i class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div style="color: red;">请上传1:1的图片比例</div>
			<!-- <el-input v-model="form.sort"  autocomplete="off" ></el-input> -->
		</el-form-item>
		<div data-v-eee9d61e="" class="el-form-item"><label class="el-form-item__label"
				style="width: 100px;">商品详情</label>
			<div  style="margin-left: 100px;">
				<quill-editor ref="text" v-model="form.imageText" class="myQuillEditor" :options="editorOption" />
			</div>
		</div>
		<div style="text-align: right;padding: 20px;">
			<el-button @click="$emit('closeMoule',false)">取 消</el-button>
			<el-button type="primary" @click="sub">确 定</el-button>
		</div>
	</el-form>
	
</template>

<script>
	import {
		quillEditor
	} from 'vue-quill-editor'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import quillConfig from './quill-config.js'
	export default {
		components: {
			quillEditor
		},
		props:["isAdd",'goodsId'],
		data() {
			return {
				webUrl:this.webUrl,
				webImgUrl:this.webImgUrl,
				headers:{
					'token':this.$store.state.token,
					// 'Content-Type': 'multipart/form-data'
				},
				editorOption: quillConfig,
				
				form: {
					goodsBannerList: [],
					goodsHead:"",//商品封面
					goodsName:"",//商品名称
					goodsNowPrice:"",//商品现价
					goodsOrgPrice:"",//商品原价
					integral:"",
					goodsTypeOneId:"",//商品一级分类id
					goodsTypeTwoId:"",//商品二级分类id
					goodsTypeThreeId:"",//商品三级分类id
					supplierId:"",//供货商id
					isHotSale:"",//热销榜单 1是2否
					isOnShelf:"",//上架状态 1上架2下架
					isOnShelf:"",//今日上新 1是2否
					label1:"",		
					label2:"",
          promotionIntegralPercent:"",
					goodsId:this.goodsId,//商品id
					imageText:"",//图文详情
					promotionState: '',
					promotionCoupons: '',
          presentParent: '',
          useJksParam: '',
          otherPromotionCoupons: '',
				},
				supplier:[],
				classGoodsType:[],
				leveGoodsType:[],
				tertiaryGoodsType:[]

			}
		},
		created() {
			this.getAllSupplier()
			this.getGoodsType()
		},
		mounted() {
			if(!this.isAdd){
				this.getDatails(this.goodsId)
			}
			
		},
		methods: {
			
			//提交
			sub() {	
				if (this.form.goodsName.length == 0) {
					this.$message('请输入商品名称');
					return false
				}
				if (this.form.goodsNowPrice.length == 0) {
					this.$message('请输入商品现价');
					return false
				}
				
				if (!this.istwoNum(this.form.goodsNowPrice)) {
					this.$message('请输入大于0的整数或者保留两位小数的商品现价');
					return false
				}
				if (this.form.goodsOrgPrice.length == 0) {
					this.$message('请输入商品原价');
					return false
				}
				if (!this.istwoNum(this.form.goodsOrgPrice)) {
					this.$message('请输入大于0的整数或者保留两位小数的商品原价');
					return false
				}
				// if (this.form.integral.length == 0) {
				// 	this.$message('请输入积分');
				// 	return false
				// }
				// if (!this.isNum(this.form.integral)) {
				// 	this.$message('请输入正确的积分');
				// 	return false
				// }
				if (this.form.goodsTypeOneId.length == 0) {
					this.$message('请选择商品一级分类');
					return false
				}
				if (this.form.goodsTypeTwoId.length == 0) {
					this.$message('请选择商品二级分类');
					return false
				}
				if (this.form.supplierId.length == 0) {
					this.$message('请选择供货商');
					return false
				}
				if (this.form.goodsHead.length == 0) {
					this.$message('请上传商品封面');
					return false
				}
				if (this.form.goodsBannerList.length == 0) {
					this.$message('请上传商品轮播图');
					return false
				}
				var url = this.isAdd ? "/goods/add" : "/goods/update"
				console.log(this.form)
				console.log(JSON.stringify(this.form))
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.$emit('closeMoule',true)
						}
					})
				} else {
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.$emit('closeMoule',true)
						}
					})
				}
			
			},
			
			
			//上传封面图片回调
			handleAvatarSuccess(res, file) {
				this.form.goodsHead = res.data.path
			},
			//上传banner图片回调
			bannerSuccess(res){
				console.log(res)
				let that=this
				this.form.goodsBannerList.push({
					path:res.data.path0,
					goodsBannerId: '',
					goodsId:that.goodsId
				})
				
			},
			onError(){
				this.$message.error("上传失败")
			},
			//删除banner
			delBanner(index){
				this.form.goodsBannerList.splice(index,1)
			},
			//获取供货商
			getAllSupplier(){
				this.httpPost("/supplier/allSupplier").then(res => {
					console.log(res)
					if (res.code == 200) {
						this.supplier=res.data
					}
				})
			},
			
			//获取一级分类
			getGoodsType() {
				this.httpPost("/goodsType/allFirstGoodsType").then(res => {
					if (res.code == 200) {
						this.classGoodsType = res.data
					}
				})
			},
			//选择一级分类
			selectClassGoodsType(e){
				this.leveGoodsType=[]
				this.tertiaryGoodsType=[]
				this.form.goodsTypeTwoId=""
				this.form.goodsTypeThreeId=""
				this.getleveGoodsType(e)
			},
			//选择二级分类
			selectLeveGoodsType(e){
				this.tertiaryGoodsType=[]
				this.form.goodsTypeThreeId=""
				this.getTertiaryGoodsType(e)
			},
			//获取二级分类
			getleveGoodsType(id) {
				this.httpPost("/goodsType/getGoodsTypeByParentId?"+this.$qs.stringify({
						goodsTypeId: id
					})).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.leveGoodsType = res.data
						if(res.data.length==0){
							this.form.goodsTypeOneId=""
							this.$message('当前一级分类没有二级分类，请重新选择');
						}
					}
				})
			},
			//获取三级分类
			getTertiaryGoodsType(id) {
				this.httpPost("/goodsType/getGoodsTypeByParentId?"+this.$qs.stringify({
						goodsTypeId: id
					})).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tertiaryGoodsType = res.data
						if(res.data.length==0){
							this.form.goodsTypeTwoId=""
							this.$message('当前二级分类没有三级分类，请重新选择');
						}
					}
				})
			},
		
			//获取详情
			getDatails(id){
				this.httpPost("/goods/getOne?"+this.$qs.stringify({
						goodsId: id
					})).then(res => {
						console.log(res)
					if (res.code == 200) {						
						this.getleveGoodsType(res.data.goodsTypeOneId)
						this.getTertiaryGoodsType(res.data.goodsTypeTwoId)
						this.form = res.data
					}
				})
			}
		},


	}
</script>



<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
	.formBox{
		height: 60vh;
		overflow-y: auto;
	}
	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
		margin-right: 10px;
	}
	::v-deep .ql-editor{
		height: 300px !important;
	}
	::v-deep .el-dialog {
	    margin: 4% auto auto auto !important;
	    max-height: 80vh;
		min-height: 80vh;
	    .el-dialog__body {
	      position: absolute;
	      left: 0;
	      top: 54px;
	      bottom: 0;
	      right: 0;
	      padding: 0;
	      z-index: 1;
	      overflow: hidden;
	      overflow-y: auto;
	      box-sizing: border-box;
	　　　　
	      &::-webkit-scrollbar {
	        width: 2px;
	        background-color: #ccc;
	      }
	      &::-webkit-scrollbar-thumb {
	        background-color: #0ae;
	      }
	      &::-webkit-scrollbar-track {
	        background-color: #ccc;
	      }
	    }
	  }
</style>
